<div 
    class="fab-container"
    [ngClass]="{'add-overlay': buttons.length}"
>

    <div 
        appClickOutside
        class="fab-container-menu"
        (clickedOutsideEmitter)="verificaClicouForaDoMenu()"
    >
    
    <button
            mat-fab
            class="fab-container-toggler fab-toggler"
            (click)="onToggleFab()"
        >
            <mat-icon [svgIcon]="'plus'" [@fabToggler]="{value: fabTogglerState}"></mat-icon>
        </button>
    
        <div 
            class="fab-container-list"
            [@speedDialStagger]="buttons.length"
        >
            <button
                class="fab-container-list-item"
                [ngClass]="{'botao-calcular': btn.calcular, 'tem-children': btn.children}"
                *ngFor="let btn of buttons"            
                [title]="btn.titulo"
      
            >
                <div class="main-item" (click)="handleItemClick(btn, $event)">
                    <div class="main-item-left">
                        <mat-icon [svgIcon]="btn.icone"></mat-icon>
                        <span class="fab-container-list-item-txt">{{btn.titulo}}</span>
                    </div>
                    <div class="main-item-right" *ngIf="btn.children">
                        <mat-icon [svgIcon]="btn.showChildren ? 'chevron-up' : 'chevron-down'"></mat-icon>
                    </div>
                </div>
    
                <div 
                    class="fab-container-list-item-children"
                    [ngClass]="{'active': btn.showChildren}"
                    *ngIf="btn.children"
                >
                    <div>
                        <button 
                            class="sub-item"
                            (click)="handleSubItemClick(subItem, $event)"
                            *ngFor="let subItem of btn.children"
                            [title]="subItem.titulo"
                        >
                            <mat-icon [svgIcon]="subItem.icone"></mat-icon>
                            <span class="fab-container-list-item-children-item">{{subItem.titulo}}</span>
                        </button>
                    </div>
                </div>
            </button>
        </div>

    </div>

</div>